export default function (currencies) {
  return [...currencies].sort((a, b) => a.srt - b.srt);
}
